import { memo } from 'react'
import styled from 'styled-components'

import { breakpoints, media } from '../../styles/media'

import BaseShareButton from '../../components/display/ShareButton'
import Button from '../../components/display/Button'
import InvisibleButton from '../../components/display/InvisibleButton'
import LazyImage from '../../components/display/LazyImage'
import Container from '../../components/layout/Container'
import PlaceholderCard from '../../components/cards/PlaceholderCard'
import { GridItem } from '../../components/layout/ItemGrid'

export const ACTIONS_BAR_HEIGHT_DESKTOP = 80

export const Loader = memo(() => (
  <>
    {[...Array(6)].map((e, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <GridItem key={i}>
        <PlaceholderCard portrait={false} />
      </GridItem>
    ))}
  </>
))

export const StickyButtonWrapper = styled(Container)`
  z-index: 3;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: ${breakpoints.md}px;
  padding: 16px;
  background-color: white;

  ${Button} {
    flex-grow: 1;
    text-transform: uppercase;

    &:not(last-child) {
      margin-bottom: 6px;
    }
  }
`

export const BucketListName = styled.span`
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  color: #ffffff;

  max-width: 1300px;
`

export const Overlay = styled.div`
  position: absolute;
  z-index: 1;
  background-color: black;
  opacity: 0.2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`
export const ShareButton = styled(BaseShareButton)`
  border: none;
  font-size: 16px;
  color: #333333;
  margin-left: auto;
`

export const Actions = styled.div<{ isSticky?: boolean; top?: number }>`
  display: flex;
  align-items: center;
  border-bottom: solid 1px #d3d3d3;
  border-top: solid 1px #d3d3d3;

  height: 65px;
  z-index: 2;
  background-color: #fff;

  & > div:first-child {
    flex-grow: 1;
  }
`

export const DesktopActions = styled.div<{ isSticky?: boolean }>`
  position: relative;
  height: ${ACTIONS_BAR_HEIGHT_DESKTOP}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 16px;
  z-index: 9;
  border-bottom: 1px solid #d1d1d1;
`

export const EditButton = styled(InvisibleButton)`
  position: absolute;
  right: 0;
  top: 0;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  color: #ffffff;

  svg {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }

  ${media.md`
    margin-top: 16px;
    margin-right: 16px;
  `}
`

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 240px;

  background-color: lightgrey;
  font-size: 32px;
  letter-spacing: 2px;
  color: #ffffff;

  @media (min-width: 540px) {
    height: 400px;
  }
  @media (min-width: 768px) {
    height: 500px;
  }

  ${LazyImage} {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }

  ${EditButton} {
    z-index: 3;
  }

  ${BucketListName} {
    z-index: 3;

    ${media.md`
      font-size: 42px;
    `}
  }
`

export const Subheading = styled.h2`
  width: 100%;
  margin: 35px 16px 16px 16px;
  font-size: 20px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.brand.forest};

  ${media.md`
    font-size: 30px;
    margin-bottom: 35px;

    &:first-child {
      margin-top: 0;
    }
  `}
`

export const SeeMoreButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 32px;
  margin-top: 16px;
  margin-bottom: 48px;

  ${Button} {
    width: 100%;
    max-width: 400px;
  }
`
